import { CommonWidgetMetrics } from '@/ts/common-types';
import { formatMetric } from '@/ts/revstack/helpers';
import React from 'react';
import Delta from './Delta';

interface DeltaTagProps {
    metric: CommonWidgetMetrics;
    value: number | string;
    unit?: string;
    className?: string;
    style?: React.CSSProperties;
    isPositive?: boolean;
}

const DeltaTag: React.FC<DeltaTagProps> = ({
    metric,
    unit,
    value,
    className = "",
    style,
    isPositive,
}) => {

    const metricKey = metric.includes(CommonWidgetMetrics.MARKET_SHARE) ? CommonWidgetMetrics.MARKET_SHARE: metric;
    return (
        <span
            className={`d-inline-flex align-items-center gap-1 fs-7 fw-500 ${isPositive ? "text-success" : "text-danger"
                } ${className}`}
            style={{
                textAlign: "right",
                ...style,
            }}
        >
            {value !== null && value !== undefined && !isNaN(Number(value)) ? (
                <>
                    {typeof isPositive === "boolean" && <Delta isPositive={isPositive} />}{" "}
                    <span>{formatMetric(metricKey, value, true)}</span>
                </>
            ) : (
                <span>-</span>
            )}
        </span>
    );  
};

export default DeltaTag